export default "__VITE_ASSET__DaW39ujK__"